var $ = require("jquery");

var CategorySelectionView = Backbone.View.extend({
  events: {
    "click [data-category-selector]": "toggleQuickQuoteTrigger",
    "change [data-category-selector]": "toggleQuickQuoteTrigger",
    "click [data-quick-quote-trigger]": "triggerQuickQuote",
    "click [data-tabs-flights]": "checkFlightTabSelection",
    "keydown [data-filter-trigger]": "mimicFilterClick"
  },

  // this is used for ADA support of the filter widget on category page
  mimicFilterClick: function(e) {
    if (e.type === "keydown" && (e.keyCode === 32 || e.keyCode === 13)) {
      $(e.currentTarget).trigger("click");
    }
  },

  toggleQuickQuoteTrigger: function() {
    if (
      this.$("[data-category-selector]:checked").length === this.settings.cabins
    ) {
      this.$("[data-quick-quote-trigger]").prop("disabled", false);
    }
  },

  triggerQuickQuote: function() {
    var data = $('[data-component="form"]').serializeJSON();

    var sendData = {
      category_ids: data.category_ids
    };

    if (data.promotions) {
      sendData.promotions = data.promotions;
    }

    if (data.flight_ids) {
      sendData.flight_ids = data.flight_ids;
    }

    window.open(
      this.settings.urls.quickQuote + "?" + $.param(sendData),
      "quickquote",
      "height=800,width=850,scrollbars=yes,resizable=yes"
    );
  },

  checkFlightTabSelection: function() {
    //Checking if the flight was selected for cruise category
    if (!this.$("[data-flight-selector]:checked").length) {
      this.$('[data-tabs-label="flights"]').click();
    }
  },

  initialize: function() {
    this.settings = {
      cabins: 1,
      urls: {}
    };

    if (this.$el.data("settings")) {
      this.settings = this.settings = $.extend(
        true,
        this.settings,
        this.$el.data("settings")
      );
    }

    if (!this.settings.urls.quickQuote) {
      this.$("[data-quick-quote-trigger]").addClass("is-hidden");
    }

    this.$el.loadComponents({ path: "cruise" });
  }
});

module.exports = CategorySelectionView;
